export const SET_RECIPES_DATA = 'SET_RECIPES_DATA';
export const setRecipesData = (recipeArray) => ({
    type: SET_RECIPES_DATA,
    payload: recipeArray
});